import { FunctionComponent, useEffect, useState } from "react";
import { yupResolver } from "@hookform/resolvers/yup";
import { useForm, SubmitHandler } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import { Button } from "../../generic";
import { auth, forms, dynamo } from "src/utils";
import { TextInputWithRegister } from "../../inputs";
import { AuthUser, useAuth } from "src/context/AuthContext";
import { userTypes } from "src/utils/types";
import SquareTile from "src/components/generic/tiles/SquareTile";

const ConfirmForgotPasswordForm: FunctionComponent = () => {
  const navigate = useNavigate();
  const { user, setUser, setTokens } = useAuth();
  const [error, setError] = useState<string>("");

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: { email: "", code: "", password: "" },
  });


  const submit: SubmitHandler<any> = async (data) => {
    const { email, code, password } = data;

    try {
        const result = await auth.cognito.confirmForgotPassword(email, code, password);
      console.log({result})

      if(result.status === 200) {
          navigate('/auth/login')
      }
    } catch (error: any) {
      setError(error?.message || "Login failed");
    }
  };

  return (
    <form>
      <SquareTile styles="max-w-[600px] mx-auto flex flex-col items-center justify-around">
        {error && <p>{error}</p>}
        <TextInputWithRegister
          label="Email"
          id="email"
          placeholder="Email address..."
          containerStyles="lg:w-[85%]"
          register={register("email")}
          error={errors?.email?.message}
        />

        <TextInputWithRegister
          label="Password"
          id="password"
          placeholder="Enter strong password..."
          containerStyles="lg:w-[85%]"
          register={register("password")}
          password
          showPasswordToggle
          error={errors?.password?.message}
        />

        <TextInputWithRegister
          label="Code"
          id="code"
          placeholder="Enter verification code..."
          containerStyles="lg:w-[85%]"
          register={register("code")}
          error={errors?.code?.message}
        />


        <Button text="Submit" styles="my-4" onClick={handleSubmit(submit)} />

        <div className="flex flex-col">
          <Link to="/client-tiers" className="text-primary self-center mb-4">
            Need to Register?
          </Link>
          <Link to="/auth/login" className="text-primary self-center mb-4">
            Login
          </Link>
        </div>
      </SquareTile>
    </form>
  );
};

export default ConfirmForgotPasswordForm;
